module.exports = __webpack_public_path__ + "img/4ne.16f22b86.svg";